import { SearchOption } from '../types';
import { MultiChannelOrderItemExcelDownloadRequestDto } from '../../../../types/api/multi-channels';

export const convertRequestBody = ({
  ids,
  searchOption,
}: {
  ids?: string[];
  searchOption: SearchOption;
}): MultiChannelOrderItemExcelDownloadRequestDto => ({
  searchOption: {
    ids: ids,
    status: searchOption.status ? searchOption.status.split(',') : undefined,
    searchDetails: [
      {
        type: searchOption.searchType,
        value: searchOption.searchValue,
      },
    ],
    dateRange: {
      type: searchOption.dateType,
      startDate: searchOption.startDate || undefined,
      endDate: searchOption.endDate || undefined,
    },
    cancelDisposer: searchOption.cancelDisposer ? searchOption.cancelDisposer.split(',') : undefined,
  },
});
